class PoHandle {
    constructor() {
        this.currentUrl = window.location.href;
        this.overlay = $('.mk-overlay');
        this.quoteWrapper = $('.mk-quote-wrapper');
        this.createQuoteBtn = $('#create-quote');
        this.closeBtn = $('.close-btn');
        this.email = $('#cartEmail')
        this.init();
    }

    init() {
        this.handleCloseBtn();
        this.handlePobtn();

        this.createQuoteBtn.on('click', () => {
            // 校验邮箱格式
            const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if(reg.test(this.email.val())) {
                $('#mk-check-quotation').removeClass('hide');
                $('#eq-email-wrapper').addClass('hide');
                $('#email-validate').remove()
            }else {
                if($('#email-validate').length === 0) {
                    $('#easyquote-status').after(`<p id="email-validate" style="font-size:18px;font-weight:600;color:red;padding-left:36px">Invalid email format</p>`)
                }
            }
            // setTimeout(() => {
            //     if ($('#easyquote-status').text().indexOf('you will receive your quote via email shortly') > -1) {
            //         $('#mk-check-quotation').removeClass('hide');
            //         $('#eq-email-wrapper').addClass('hide');
            //     }
            // }, 1500);
        });

        this.overlay.on('click', () => {
            this.closePoDialog();
        })

    }
    isSourceEqualPopupCart() {
        return __MakeBlock_Utils.getWindowLocationQueryString('source') === 'popup-cart';
    }
    handleCloseBtn() {
        this.closeBtn.on('click', () => {
            this.closePoDialog();
        });
    }
    handlePobtn() {
        $('body').on('click', '.get-po-btn', (e) => {
            e.preventDefault();
            if (!this.isInCartPage()) {
                window.location.href = e.target.href;
            } else {
                this.openPoDialog();
            }
        });
    }

    isInCartPage() {
        // 判断 URL 中是否包含 "/cart" 路径
        return /\b\/cart\b/.test(this.currentUrl);
    }
    debounce(func, delay) {
        let timerId;
        return function (...args) {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = setTimeout(() => {
                func.apply(this, args);
                timerId = null;
            }, delay);
        };
    }
    openPoDialog() {
        // 打开弹窗，恢复至第一步
        $('#mk-check-quotation').addClass('hide');
        $('#eq-email-wrapper').removeClass('hide');
        $('#easyquote-status').text('')
        $('#eq-email-wrapper input').val(null)
        this.quoteWrapper.fadeIn();
        this.overlay.fadeIn();
    }
    closePoDialog() {
        this.quoteWrapper.fadeOut();
        this.overlay.fadeOut();
    }
    isMobile() {
        return window.innerWidth <= 768;
    }
}
